module.exports = __webpack_public_path__ + "img/heart_red.86f6c37b.svg";